import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';
import classNames from 'classnames';

import { APPS } from 'rebook/apps/base/components/apps/constants';

import {
  ABOUT_MYBOOK_ITEMS, ABOUT_SUBSCRIPTION_ITEMS, MENU_ITEMS, CONTACT_ITEMS, SOCIAL_PUBLICS,
} from './constants';
import styles from './style.scss';


const appItems = Object.keys(APPS).map((key) => APPS[key]);

const FooterInnerLink = ({ item, children, extraClassName }) => (
  <li className={classNames(styles.item, extraClassName)}>
    <Link to={item.url}>
      {children}
    </Link>
  </li>
);

const FooterOuterLink = ({ item, url, children, extraClassName }) => (
  <li className={classNames(styles.item, extraClassName)}>
    <a href={url || item.url} className="link">
      {children}
    </a>
  </li>
);

const Footer = ({ user }) => (
  <React.Fragment>
    <div className={styles.topContent}>
      <div className={styles.content}>
        <div className={styles.aboutLinkList}>
          <div className={styles.aboutLinkContainer}>
            <p className={styles.footerTopTitle}>О проекте MyBook</p>
            {ABOUT_MYBOOK_ITEMS.map((item) => {
              return item.outerlink
                ? (
                  <FooterOuterLink key={item.url} item={item}>
                    <small className="link">
                      {item.text}
                    </small>
                  </FooterOuterLink>
                )
                : (
                  <FooterInnerLink key={item.id || item.url} item={item}>
                    <small className="link">
                      {item.text}
                    </small>
                  </FooterInnerLink>
                );
            })}
          </div>
          <div className={styles.aboutLinkContainer}>
            <p className={styles.footerTopTitle}>О подписке</p>
            {ABOUT_SUBSCRIPTION_ITEMS.map((item) => {
              return item.outerlink
                ? (
                  <FooterOuterLink key={item.url} item={item}>
                    <small className="link">
                      {item.text}
                    </small>
                  </FooterOuterLink>
                )
                : (
                  <FooterInnerLink key={item.id || item.url} item={item}>
                    <small className="link">
                      {item.text}
                    </small>
                  </FooterInnerLink>
                );
            })}
          </div>
        </div>
        <div className={styles.externalLinkList}>
          {MENU_ITEMS.map((item) => {
            if (!user && item.isForAuthenticatedUser) {
              return null;
            }

            return item.outerlink
              ? (
                <div key={item.url} className={styles.externalLinkContainer}>
                  <FooterOuterLink item={item}>
                    <b>{item.text}</b>
                  </FooterOuterLink>
                </div>
              )
              : (
                <div key={item.url} className={styles.externalLinkContainer}>
                  <FooterInnerLink item={item}>
                    <div className="link">
                      <b>{item.text}</b>
                    </div>
                  </FooterInnerLink>
                </div>
              );
          })}
          <div className={styles.paymentMethodsContainer}>
            <small className={styles.footerTinyTitle}>Мы принимаем к оплате</small>
            <div className={styles.paymentMethodList}>
              <div className={styles.visaIcon} />
              <div className={styles.mastercardIcon} />
              <div className={styles.mirIcon} />
              <div className={styles.paypalIcon} />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className={styles.bottomContent}>
      <div className={styles.content}>
        <div className={styles.extraResourcesContainer}>
          <div className={styles.appList}>
            <small className={styles.footerShortTitle}>Скачать приложение</small>
            <div className={styles.appsIconList}>
              {appItems.map((item) => {
                const qs = queryString.stringify({
                  pagetype: 'site_footer',
                });

                return (
                  <FooterOuterLink
                    key={item.name}
                    url={`${item.installUrl}?${qs}`}
                    extraClassName={`jest-footer-${item.name}-link`}>
                    <div className={styles.icon}>{item.icon}</div>
                  </FooterOuterLink>
                );
              })}
            </div>
          </div>
          <div className={styles.socials}>
            <small className={styles.footerShortTitle}>Следите за новостями</small>
            <div className={styles.socialList}>
              {SOCIAL_PUBLICS.map((item) => (
                <FooterOuterLink key={item.id} item={item}>
                  <div className={styles.itemContent}>
                    <div className={styles.icon}>{item.icon}</div>
                  </div>
                </FooterOuterLink>
              ))}
            </div>
          </div>
        </div>
        <div className={styles.supportContainer}>
          <small className={styles.footerShortTinyTitle}>Служба поддержки</small>
          <div className={styles.supportLinks}>
            {CONTACT_ITEMS.map((item) => (
              <FooterOuterLink
                key={item.id}
                item={item}
                extraClassName={item.id === 0 ? styles.isBordered : ''}>
                {item.text}
              </FooterOuterLink>
            ))}
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>
);

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps)(Footer);
